import React from "react";
import { X } from "lucide-react";
import "./ButtonClose.css";

export default function ButtonClose({
  onClick,
  ariaLabel = "Close",
  size = 20,
  className = "",
  disabled = false,
  style,
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`user-modal-close-btn ${className}`.trim()}
      aria-label={ariaLabel}
      disabled={disabled}
      style={style}
    >
      <X size={size} />
    </button>
  );
}
